// extracted by mini-css-extract-plugin
export var redoItem = "_ol-1";
export var redoTrigger = "_ol-0";